import React, { useCallback, useEffect, useState } from "react";
import {
  API,
  fileUpload,
  TableClasses,
  TableWrapClasses,
  TDClasses,
  THClasses,
  TRClasses,
} from "../../../config";
import {
  capitalizeSingleWord,
  formatNumber,
  padWithLeadingZeros,
} from "../../../lib/Misc";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faSatelliteDish } from "@fortawesome/free-solid-svg-icons";
import BootstrapTable from "react-bootstrap-table-next";
import CustomTooltip from "../../../components/CustomTooltip";
import { ResponsiveDrawerForm } from "../../../components/ResponsiveDrawerForm";
import MainBody from "../../../components/MainBody/MainBody";

const ExpandOrgSubscription = ({ id }) => {
  const [billingData, setBillingData] = useState([]);
  const [loading2, setLoading2] = useState(false);
  const [upcomingInvoice, setUpcomingInvoice] = useState();
  const [infoUpcomingInvoiceModal, setInfoUpcomingInvoiceModal] =
    useState(false);
  const [loading, setLoading] = useState(false);

  const [planId, setPlanId] = useState();

  const fetchBillingData = useCallback(async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("organization_id", id);
      const activeRes = await fileUpload(
        API.GET_SUBSCRIPTION_DETAILS,
        formData
      );
      let billingHistory = activeRes.data?.data?.subscriptions?.map((item) => {
        return {
          ...item,
          amount: item?.price,
        };
      });
      setBillingData(billingHistory);
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    fetchBillingData();
  }, [fetchBillingData]);

  // *API For Fetching the Upcoming invoice details - Start
  const fetchUpcomingInvoice = useCallback(
    async (price_id) => {
      try {
        setLoading2(true);
        const formData = new FormData();
        if (id) {
          formData.append("organization_id", id);
        }
        formData.append("price_id", price_id);
        formData.append("quantity", 1);
        const { data } = await fileUpload(API.GET_UPCOMING_INVOICE, formData);
        if (data) {
          setLoading2(false);
          setUpcomingInvoice(data.data);
        } else {
          setLoading2(false);
          setUpcomingInvoice();
        }
      } catch (error) {
        setLoading2(false);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [id]
  );

  useEffect(() => {
    if (infoUpcomingInvoiceModal && planId) {
      fetchUpcomingInvoice(planId);
    }
  }, [planId, fetchUpcomingInvoice, infoUpcomingInvoiceModal]);

  const toggleUpcomingInvoiceList = () => {
    if (infoUpcomingInvoiceModal) {
      setPlanId();
    }
    setInfoUpcomingInvoiceModal(!infoUpcomingInvoiceModal);
  };

  const dollarNumberFormat = (data) => {
    if (Number(data) < 0) {
      return `-$${formatNumber(Math.abs(Number(data)))}`;
    } else {
      return `$${formatNumber(Math.abs(Number(data)))}`;
    }
  };

  const viewJournalDataGenerator = (quantity) => {
    const items = [];
    let mainData = upcomingInvoice?.lines?.data;
    let discountTotalValue = 0;
    let SubTotalValue = 0;
    let TaxValue = 0;
    let TotalValue = 0;

    let planSubTotal = 0;
    let planTaxValue = 0;
    let planDiscountValue = 0;
    let planTotalValue = 0;
    // let lastItem = 0;

    for (let i = 0; i < quantity; i++) {
      SubTotalValue = SubTotalValue + Number(mainData[i]?.amount / 100);
      TaxValue = TaxValue + Number(mainData[i]?.taxes[0]?.amount / 100);
      discountTotalValue =
        discountTotalValue +
        Number(mainData[i]?.discount_amounts?.[0]?.amount / 100);
      TotalValue =
        TotalValue +
        (Number(mainData[i]?.amount / 100) +
          Number(mainData[i]?.taxes[0]?.amount / 100));

      var startDate = new Date(Number(mainData[i]?.period?.start) * 1000);
      var formattedStartDate =
        padWithLeadingZeros(Number(startDate.getUTCDate()), 2) +
        "-" +
        padWithLeadingZeros(Number(startDate.getUTCMonth() + 1), 2) +
        "-" +
        startDate.getUTCFullYear();
      var endDate = new Date(Number(mainData[i]?.period?.end) * 1000);
      var formattedEndDate =
        padWithLeadingZeros(Number(endDate.getUTCDate()), 2) +
        "-" +
        padWithLeadingZeros(Number(endDate.getUTCMonth() + 1), 2) +
        "-" +
        endDate.getUTCFullYear();

      let planSubTotalCalc = 0;

      planSubTotal = Number(planSubTotal) + Number(planSubTotalCalc);

      let planTaxCalc = 0;

      planTaxValue = Number(planTaxValue) + Number(planTaxCalc);

      let planDiscountCalc = 0;

      planDiscountValue = Number(planDiscountValue) + Number(planDiscountCalc);

      let planTotalCalc = 0;

      planTotalValue = Number(planTotalValue) + Number(planTotalCalc);

      items.push({
        key: mainData[i]?.id,
        start_date: formattedStartDate ? formattedStartDate : "-",
        end_date: formattedEndDate ? formattedEndDate : "-",
        description: mainData[i]?.description ? mainData[i]?.description : "-",
        plan_sub_total: planSubTotalCalc
          ? dollarNumberFormat(Number(planSubTotalCalc))
          : "-",
        plan_gst: planTaxCalc ? dollarNumberFormat(Number(planTaxCalc)) : "-",
        plan_discount: planDiscountCalc
          ? dollarNumberFormat(Number(planDiscountCalc))
          : "-",
        plan_total: planTotalCalc
          ? dollarNumberFormat(Number(planTotalCalc))
          : "-",
        sub_total: mainData[i]?.amount
          ? dollarNumberFormat(Number(mainData[i]?.amount / 100))
          : "$0.00",
        tax: mainData[i]?.taxes[0]?.amount
          ? dollarNumberFormat(Number(mainData[i]?.taxes[0]?.amount / 100))
          : "$0.00",
        discount: mainData[i]?.discount_amounts?.[0]?.amount
          ? dollarNumberFormat(
              Number(mainData[i]?.discount_amounts?.[0]?.amount / 100)
            )
          : "$0.00",
        total_amount: mainData[i]?.amount
          ? dollarNumberFormat(
              Number(mainData[i]?.amount / 100) +
                Number(mainData[i]?.taxes[0]?.amount / 100)
            )
          : 0,
      });

      if (i === quantity - 1) {
        items.push({
          description: (
            <div style={{ textAlign: "right" }}>
              <strong>Prorated amlount to be added in the next invoice:</strong>
            </div>
          ),
          sub_total: (
            <strong>
              {SubTotalValue
                ? dollarNumberFormat(Number(SubTotalValue))
                : "$0.00"}
            </strong>
          ),
          tax: (
            <strong>
              {TaxValue ? dollarNumberFormat(Number(TaxValue)) : "$0.00"}
            </strong>
          ),
          discount: (
            <strong>
              {discountTotalValue
                ? dollarNumberFormat(Number(discountTotalValue))
                : "$0.00"}
            </strong>
          ),
          total_amount: (
            <strong>
              {TotalValue ? dollarNumberFormat(Number(TotalValue)) : "$0.00"}
            </strong>
          ),
        });
      }
    }
    return items;
  };
  const viewJournalData = viewJournalDataGenerator(
    upcomingInvoice?.lines?.data?.length
  );

  const viewColumns = [
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "start_date",
      text: "Start Date",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "end_date",
      text: "End Date",
    },

    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "description",
      text: "Description",
    },

    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "sub_total",
      text: "Sub Total",
      headerStyle: {
        textAlign: "right",
      },
      style: {
        textAlign: "right",
      },
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "tax",
      text: "Tax",
      headerStyle: {
        textAlign: "right",
      },
      style: {
        textAlign: "right",
      },
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "discount",
      text: "Discount",
      headerStyle: {
        textAlign: "right",
      },
      style: {
        textAlign: "right",
      },
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "total_amount",
      text: "Amount",
      headerStyle: {
        textAlign: "right",
      },
      style: {
        textAlign: "right",
      },
    },
  ];

  // *API For Fetching the Upcoming invoice details - End

  const columns = [
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "subscription_start_date",
      text: "Start Date",
      sort: true,
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "subscription_end_date",
      text: "End Date",
      sort: true,
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "name",
      text: "Name",
      sort: true,
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "amount",
      text: "Amount",
      sort: true,
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "tax_price",
      text: "Tax Amount",
      sort: true,
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "total_price",
      text: "Total Amount",
      sort: true,
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "status",
      text: "Status",
      sort: true,
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "action",
      text: "Action",
      align: "center",
      headerAlign: "center",
      style: { width: "127px" },
    },
  ];

  const billingsGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        key: billingData[i]?.id,
        subscription_start_date: billingData[i]?.subscription_start_date
          ? billingData[i]?.subscription_start_date
          : "-",
        subscription_end_date: billingData[i]?.subscription_end_date
          ? billingData[i]?.subscription_end_date
          : "-",
        name: billingData[i]?.metadata.name
          ? billingData[i]?.metadata.name
          : "-",
        amount: billingData[i]?.amount ? `$${billingData[i]?.amount}` : "$0.00",
        tax_price: billingData[i]?.tax_price
          ? `$${billingData[i]?.tax_price}`
          : "$0.00",
        total_price: billingData[i]?.total_price
          ? `$${billingData[i]?.total_price}`
          : "$0.00",
        status: billingData[i]?.status
          ? `${capitalizeSingleWord(billingData[i]?.status)}`
          : "-",
        action: (
          <>
            <span className="flex items-center gap-2 justify-center">
              {billingData[i]?.invoice_url && (
                <CustomTooltip message={"View Invoice"}>
                  <a
                    href={billingData[i]?.invoice_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-sm btn-outline-primary"
                  >
                    <FontAwesomeIcon icon={faEye} />
                  </a>
                </CustomTooltip>
              )}
              {billingData[i]?.invoice_url &&
                billingData[i]?.status === "active" && <span>/</span>}
              {billingData[i]?.status === "active" && (
                <CustomTooltip message={"Upcoming Invoice"}>
                  <span>
                    <FontAwesomeIcon
                      icon={faSatelliteDish}
                      size="1x"
                      onClick={() => {
                        toggleUpcomingInvoiceList();
                        setPlanId(billingData[i]?.price_id);
                      }}
                    />
                  </span>
                </CustomTooltip>
              )}
            </span>
          </>
        ),
      });
    }
    return items;
  };

  const billings = billingsGenerator(billingData?.length);
  return (
    <MainBody
      expandList={true}
      parentHeight={true}
      loading={loading || loading2}
      search={false}
      mainClassName="p-0"
      className="p-0"
    >
      <div className="custom-table">
        <div className={"table-body-class"}>
          <BootstrapTable
            keyField="id"
            data={billings ? billings : []}
            columns={columns}
            noDataIndication="No billing history found"
            rowClasses={TRClasses}
            classes={TableClasses}
            wrapperClasses={TableWrapClasses}
          />
        </div>
        {!loading2 && (
          <ResponsiveDrawerForm
            description={""}
            title={"Upcoming Invoice"}
            handleOpen={() => {}}
            handleClose={() => {
              setInfoUpcomingInvoiceModal(false);
              setPlanId();
            }}
            className={"md:w-[90vw]"}
            open={infoUpcomingInvoiceModal}
            buttonClassName={""}
            setOpen={setInfoUpcomingInvoiceModal}
            read={true}
          >
            <div className="custom-table">
              <div className={"table-body-class w-full"}>
                <BootstrapTable
                  keyField="key"
                  data={viewJournalData}
                  columns={viewColumns}
                  noDataIndication="No Data Found"
                  rowClasses={TRClasses}
                  classes={TableClasses}
                  wrapperClasses={TableWrapClasses}
                />
              </div>
            </div>
          </ResponsiveDrawerForm>
        )}
      </div>
    </MainBody>
  );
};

export default ExpandOrgSubscription;
